import {asyncRouterMap, constantRoutes} from '@/router'
/**
 * 使用meta.role确定当前用户是否具有权限
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    if (route.path === "*") {
      return true
    } else if (route.children && route.children[0].meta.roles.length > 0) {
      return true
    }
  }
}

/**
 * 通过递归过滤异步路由表
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = {...route}
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

/**
 * asyncRouterMap 动态路由 配置权限使用
 * constantRoutes 静态路由
 * 用户菜单权限
 * @type {{mutations: {SET_ROUTERS: userPermission.mutations.SET_ROUTERS}, state: {routers: *, addRouters: Array}, actions: {generateRoutes({commit: *}, *): *}}}
 */
const userPermission = {
  state: {
    routers: constantRoutes,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRoutes.concat(routers)
    }
  },
  actions: {
    generateRoutes({commit}, data) {
      return new Promise(resolve => {
        var { roles } = data;
        let accessedRouters;
        for (var i = 0; i < roles.length; i++) {
          for (var j = 0; j < asyncRouterMap.length; j++) {
            var item = asyncRouterMap[j].children;
            if (asyncRouterMap[j].meta) { //判断当前路由是否存在meta（一级路由不存在meta）
              if (asyncRouterMap[j].meta.id === roles[i]) {
                asyncRouterMap[j].meta.roles = [roles[i]];
                break;
              } else {
                for (var m = 0; m < item.length; m++) {//二级路由遍历
                  if (item[m].meta.id === roles[i]) {
                    item[m].meta.roles = [roles[i]];
                  }
                  // if (item[m].children) {//三级路由遍历
                  //     var items = item[m].children;
                  //     for (var k = 0; k < items.length; k++) {
                  //         if (items[k].meta.id === roles[i]) {
                  //             items[k].meta.roles = [roles[i]];
                  //             break;
                  //         }
                  //     }
                  // }
                }
              }
            } else {
              if (item && item.length > 0) {
                if (item[0].meta.id === roles[i]) {
                  item[0].meta.roles = [roles[i]];
                  break;
                }
              }
            }
          }
        }
        accessedRouters = filterAsyncRoutes(asyncRouterMap, roles)
        commit('SET_ROUTERS', accessedRouters)
        resolve(accessedRouters)
      })
    }
  }
}

export default userPermission
